import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class ExternalRedirectGuard {
	canActivate(
		next: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot
	): boolean {
		const url = next.paramMap.get('url');
		if (!this.isSafeHttpUrl(url)) {
			return true;
		}
		// `noopener,noreferrer` severs `window.opener` (reverse tabnabbing)
		// and strips the Referer so the destination can't read the in-app URL.
		window.open(url as string, '_blank', 'noopener,noreferrer');
		return false;
	}

	/**
	 * Only well-formed absolute http(s) URLs may be opened. Rejects
	 * `javascript:`, `data:`, `file:`, `blob:`, empty, relative and
	 * protocol-relative (`//host`) values, which either execute script or abuse the
	 * trusted origin for an open redirect.
	 */
	private isSafeHttpUrl(raw: string | null): boolean {
		if (!raw) {
			return false;
		}
		let parsed: URL;
		try {
			parsed = new URL(raw);
		} catch {
			return false;
		}
		return parsed.protocol === 'http:' || parsed.protocol === 'https:';
	}
}
